import { render, staticRenderFns } from "./FormSpinbuttonInline.vue?vue&type=template&id=70b406a8&"
import script from "./FormSpinbuttonInline.vue?vue&type=script&lang=js&"
export * from "./FormSpinbuttonInline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports